<template>
  <div class="footer-developers">
    <div class="footer-developers__block">
      <span class="footer-developers__item">
        <svg class="footer-developers__sens-logo"><use xlink:href="#svg-logo-sense"></use></svg>
        Designed by <br />
        Sense Production
      </span>
      <span class="footer-developers__item">
        Development by <br v-if="screenWidth >= 768" />
        AniArt
      </span>
    </div>
    <div class="payments-logo">
      <svg
        width="31"
        height="25"
        viewBox="0 0 31 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2227_9691)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.12697 24.3813V22.9835C5.12697 22.5483 4.9415 22.311 4.57056 22.311C4.19962 22.311 3.94791 22.5483 3.94791 22.9835V24.3813H3.3915V22.9835C3.3915 22.5483 3.20603 22.311 2.84834 22.311C2.46415 22.311 2.22569 22.5483 2.22569 22.9835V24.3813H1.66928V21.8626H2.21244V22.1659C2.4244 21.8758 2.68936 21.7967 2.95432 21.7967C3.33851 21.7967 3.61671 21.9681 3.78893 22.245C4.0274 21.889 4.35859 21.7967 4.68979 21.7967C5.29919 21.7967 5.68338 22.2055 5.68338 22.7989V24.3813H5.12697ZM13.9103 22.3637H13.0094V23.4978C13.0094 23.7483 13.1022 23.9198 13.3804 23.9198C13.5261 23.9198 13.6983 23.8802 13.8706 23.7747L14.0295 24.2494C13.8573 24.3681 13.5791 24.4472 13.3406 24.4472C12.6915 24.4472 12.453 24.0912 12.453 23.511V22.3637H11.9496V21.8626H12.453V21.0978H13.0094V21.8626H13.9103V22.3637ZM19.0107 21.8626L18.8385 22.3769C18.7193 22.3373 18.6 22.3241 18.4941 22.3241C18.1364 22.3241 17.9509 22.5483 17.9509 22.9703V24.3813H17.4077V21.8626H17.9509V22.1659C18.0966 21.9417 18.2953 21.7967 18.6133 21.7967C18.7325 21.7967 18.8915 21.823 19.0107 21.8626ZM11.274 22.5088C11.115 22.4033 10.8103 22.2846 10.4791 22.2846C10.1744 22.2846 10.0022 22.4033 10.0022 22.5879C10.0022 22.7461 10.1877 22.7989 10.4261 22.8252L10.6911 22.8648C11.2342 22.9439 11.5787 23.1813 11.5787 23.6165C11.5787 24.1044 11.1547 24.4472 10.4129 24.4472C10.0022 24.4472 9.61799 24.3417 9.32654 24.1176L9.57825 23.6956C9.76372 23.8274 10.0419 23.9593 10.4261 23.9593C10.7971 23.9593 10.9958 23.8406 10.9958 23.6428C10.9958 23.511 10.8633 23.4318 10.5586 23.3791L10.2936 23.3527C9.72398 23.2736 9.41928 23.0099 9.41928 22.6011C9.41928 22.1 9.82996 21.7967 10.4791 21.7967C10.8765 21.7967 11.2475 21.889 11.5124 22.0604L11.274 22.5088ZM26.668 21.8758L26.4958 22.3901C26.3765 22.3373 26.2573 22.3241 26.1513 22.3241C25.7936 22.3241 25.6082 22.5615 25.6082 22.9703V24.3813H25.0518V21.8626H25.6082V22.1659C25.7406 21.9549 25.9526 21.7967 26.2706 21.7967C26.3765 21.7967 26.5355 21.8231 26.668 21.8758ZM20.521 21.7967C20.9052 21.7967 21.1569 21.889 21.4351 22.1L21.1701 22.5483C20.9582 22.4033 20.7462 22.3241 20.5077 22.3241C20.0706 22.3241 19.7394 22.6406 19.7394 23.1285C19.7394 23.6165 20.0706 23.9329 20.5077 23.9329C20.7462 23.9329 20.9582 23.8538 21.1701 23.7088L21.4351 24.1439C21.1569 24.3681 20.9052 24.4472 20.521 24.4472C19.7129 24.4472 19.1697 23.8934 19.1697 23.1285C19.1697 22.3637 19.7129 21.7967 20.521 21.7967ZM24.3364 24.3813H23.78V24.078C23.6077 24.3022 23.3428 24.4472 22.9851 24.4472C22.2697 24.4472 21.7133 23.8934 21.7133 23.1285C21.7133 22.3505 22.2697 21.7967 22.9851 21.7967C23.3428 21.7967 23.6077 21.9417 23.78 22.1659V21.8626H24.3364V24.3813ZM23.0513 23.9329C23.5018 23.9329 23.8065 23.5769 23.8065 23.1285C23.8065 22.667 23.5018 22.311 23.0513 22.311C22.5744 22.311 22.283 22.6802 22.283 23.1285C22.283 23.5637 22.5744 23.9329 23.0513 23.9329ZM16.8381 23.1285C16.8381 23.1989 16.8337 23.2692 16.8248 23.3395H14.9436C15.0231 23.7879 15.3411 23.9461 15.6988 23.9461C15.9505 23.9461 16.2287 23.8538 16.4406 23.6824L16.7056 24.0912C16.4009 24.3549 16.0565 24.4472 15.6723 24.4472C14.9171 24.4472 14.374 23.9198 14.374 23.1285C14.374 22.3373 14.8906 21.7967 15.6325 21.7967C16.3479 21.7967 16.8248 22.3373 16.8381 23.1285ZM14.9436 22.9044H16.2684C16.2022 22.5088 15.977 22.2846 15.6193 22.2846C15.2351 22.2846 15.0099 22.5351 14.9436 22.9044ZM29.45 24.3813H28.8936V24.078C28.7214 24.3022 28.4565 24.4472 28.0988 24.4472C27.3834 24.4472 26.827 23.8934 26.827 23.1285C26.827 22.3505 27.3834 21.7967 28.0988 21.7967C28.4565 21.7967 28.7214 21.9417 28.8936 22.1659V20.8472H29.45V24.3813ZM28.165 23.9329C28.6154 23.9329 28.9201 23.5901 28.9201 23.1285C28.9201 22.667 28.6154 22.3241 28.165 22.3241C27.6881 22.3241 27.3966 22.6802 27.3966 23.1285C27.3966 23.5637 27.6881 23.9329 28.165 23.9329ZM8.78338 24.3813H8.24022V24.078C8.05475 24.3022 7.78979 24.4472 7.4321 24.4472C6.72996 24.4472 6.17355 23.8934 6.17355 23.1285C6.17355 22.3505 6.72996 21.7967 7.4321 21.7967C7.78979 21.7967 8.05475 21.9417 8.24022 22.1659V21.8626H8.78338V24.3813ZM7.49834 23.9329C7.96201 23.9329 8.26671 23.5769 8.26671 23.1285C8.26671 22.667 7.96201 22.311 7.49834 22.311C7.02141 22.311 6.72996 22.6802 6.72996 23.1285C6.72996 23.5637 7.02141 23.9329 7.49834 23.9329ZM14.6522 17.8274C14.7317 17.8978 14.8112 17.9637 14.8906 18.0252C13.3671 19.0274 11.5522 19.6077 9.60475 19.6077C4.3321 19.6077 0.0662842 15.3615 0.0662842 10.1132C0.0662842 4.86481 4.3321 0.618652 9.60475 0.618652C11.5522 0.618652 13.3671 1.19887 14.8906 2.20107C14.8112 2.2714 14.7317 2.33733 14.6522 2.39887C12.4133 4.33733 11.115 7.15931 11.115 10.1132C11.115 13.067 12.4133 15.889 14.6522 17.8274ZM30.9338 10.1132C30.9338 15.3615 26.668 19.6077 21.3953 19.6077C19.4479 19.6077 17.633 19.0274 16.1094 18.0252C16.1889 17.9637 16.2684 17.8978 16.3479 17.8274C18.5868 15.889 19.8851 13.067 19.8851 10.1132C19.8851 7.15931 18.5868 4.33733 16.3479 2.39887C16.2684 2.33733 16.1889 2.2714 16.1094 2.20107C17.633 1.19887 19.4479 0.618652 21.3953 0.618652C26.668 0.618652 30.9338 4.86481 30.9338 10.1132ZM15.8577 2.95272C17.8714 4.69338 19.1432 7.25162 19.1432 10.1132C19.1432 12.9747 17.8714 15.5329 15.8577 17.2736C15.7429 17.3791 15.6237 17.4802 15.5 17.5769C15.3764 17.4802 15.2572 17.3791 15.1424 17.2736C13.1287 15.5329 11.8569 12.9747 11.8569 10.1132C11.8569 7.25162 13.1287 4.69338 15.1424 2.95272C15.2572 2.84722 15.3764 2.74612 15.5 2.64942C15.6237 2.74612 15.7429 2.84722 15.8577 2.95272Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_2227_9691">
            <rect width="31" height="24" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>

      <svg
        width="56"
        height="25"
        viewBox="0 0 56 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2227_9693)">
          <path
            d="M10.5831 3.59496C11.2424 2.76182 11.6898 1.64315 11.5718 0.5C10.6067 0.548485 9.4289 1.14329 8.74702 1.97709C8.13478 2.69111 7.59289 3.85662 7.73415 4.95184C8.81758 5.04679 9.9 4.40473 10.5831 3.59496Z"
          />
          <path
            d="M11.5603 5.16562C9.98691 5.07094 8.64914 6.06779 7.89777 6.06779C7.14598 6.06779 5.99538 5.21334 4.75091 5.23637C3.13116 5.26041 1.62821 6.18565 0.806254 7.65723C-0.884367 10.6011 0.3601 14.9679 2.00414 17.3655C2.80253 18.5517 3.76471 19.8578 5.03255 19.8108C6.23044 19.7634 6.69996 19.0273 8.15605 19.0273C9.61105 19.0273 10.034 19.8108 11.302 19.7871C12.617 19.7634 13.4392 18.6003 14.2375 17.413C15.1534 16.0608 15.5283 14.7552 15.5519 14.6835C15.5283 14.6597 13.0162 13.6861 12.9929 10.7667C12.9692 8.32229 14.9652 7.15956 15.0592 7.08745C13.932 5.40325 12.1709 5.21334 11.5603 5.16562Z"
          />
          <path
            d="M25.2598 1.85745C28.6795 1.85745 31.0608 4.23897 31.0608 7.70628C31.0608 11.186 28.6306 13.5798 25.1741 13.5798H21.3877V19.6631H18.6521V1.85745H25.2598ZM21.3877 11.26H24.5266C26.9085 11.26 28.2639 9.96451 28.2639 7.71865C28.2639 5.47305 26.9085 4.1897 24.5389 4.1897H21.3877V11.26Z"
          />
          <path
            d="M31.7756 15.9738C31.7756 13.7032 33.4978 12.309 36.5514 12.1361L40.0687 11.9265V10.9271C40.0687 9.48332 39.1036 8.61958 37.4918 8.61958C35.9647 8.61958 35.012 9.35979 34.7803 10.5198H32.2887C32.4352 8.17522 34.4136 6.44774 37.5893 6.44774C40.7037 6.44774 42.6944 8.11357 42.6944 10.7171V19.6632H40.1661V17.5284H40.1054C39.3604 18.9722 37.7359 19.8852 36.0505 19.8852C33.5344 19.8852 31.7756 18.3058 31.7756 15.9738ZM40.0687 14.8016V13.7775L36.9052 13.9747C35.3296 14.0859 34.4382 14.7893 34.4382 15.8998C34.4382 17.0349 35.3663 17.7753 36.7832 17.7753C38.6273 17.7753 40.0687 16.4919 40.0687 14.8016Z"
          />
          <path
            d="M45.0812 24.4384V22.2789C45.2762 22.3281 45.7158 22.3281 45.9359 22.3281C47.1572 22.3281 47.8168 21.8101 48.2197 20.4775C48.2197 20.4526 48.4519 19.6878 48.4519 19.6753L43.8109 6.68196H46.6686L49.9178 17.2445H49.9662L53.2154 6.68196H56L51.1875 20.3415C50.0887 23.4882 48.8185 24.5 46.1559 24.5C45.9358 24.5 45.2762 24.4753 45.0812 24.4384Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_2227_9693">
            <rect width="56.0002" height="24" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>

      <svg
        width="59"
        height="25"
        viewBox="0 0 59 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2227_9695)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.65349 3.5C10.4235 3.5 11.8002 4.46775 11.8002 5.8226L12.47 13.672C12.4673 13.6662 12.4647 13.6604 12.462 13.6546L12.98 15.6935L17.6999 3.887H22.4199L15.1433 21.3065H10.03L5.55027 6.05982C3.93973 5.09038 2.08791 4.32294 0.00012207 3.8871V3.5H8.65349ZM21.4366 21.3065L24.3867 3.887H29.1067L26.1567 21.3065H21.4366ZM35.99 8.91929C35.99 9.69349 36.9734 10.2741 38.5467 11.0483L38.7434 11.2419C41.4967 12.4032 42.6767 13.758 42.6767 15.6935C42.6767 19.1774 39.5301 21.5 34.4166 21.5C32.45 21.5 30.2867 21.1129 29.3033 20.7258L29.8934 16.8549L30.4833 17.0484C31.8914 17.7206 33.4421 18.0524 35.0067 18.0161C36.3834 18.0161 37.7601 17.4355 37.7601 16.2741C37.7601 15.6935 37.17 15.1128 35.2033 14.3387C33.63 13.5645 31.27 12.0161 31.27 9.69349C31.27 6.40315 34.4166 4.08055 39.1367 4.08055C40.5485 4.10134 41.9459 4.3633 43.2668 4.85475L42.48 8.1451H42.0867C40.9775 7.63815 39.7697 7.374 38.5467 7.3709C36.7767 7.3709 35.99 8.1451 35.99 8.91929ZM51.5268 3.887H55.0667L59.0001 21.3065H54.8701L54.0834 17.8226H48.5767L47.2 21.3065H42.0867L49.1668 5.4354C49.56 4.2741 50.5434 3.887 51.5268 3.887ZM51.7234 8.53219L49.7568 14.3387H53.1001L51.7234 8.53219Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_2227_9695">
            <rect width="59" height="24" transform="translate(0.00012207 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div v-if="props.messages" class="footer-developers__sova" v-html="props.messages.rights"></div>
  </div>
</template>

<script setup>
// import {definePr}
import useScreenWidth from '@use/useScreenWidth';

const screenWidth = useScreenWidth();
const props = defineProps(['messages']);
// export default {
//   name: 'FooterDevelopers',
//   props: ['messages'],
// };
</script>

<style lang="scss" scoped>
.footer-developers {
  display: grid;
  grid-row-gap: 16px;
  grid-template-columns: minmax(0, 1fr);
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.4);
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-row-gap: 24px;
    //padding: 24px 0;
  }
  @include point-lg {
    padding: 32px 0;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  &__sova {
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    order: 3;
    @include point-md {
      justify-self: flex-end;
    }
  }
  &__sens-logo {
    display: block;
    width: 49px;
    height: 35px;
    margin-right: 12px;
    transition: 0.2s linear fill, 0.2s linear transform;
    fill: #fff;
    &:hover {
      transform: scale(1.1);
      fill: var(--color-link-hover-dark);
    }
  }
  &__block {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    order: 2;
    @include point-md {
      grid-template-columns: minmax(0, 1fr) minmax(0, 0.6fr);
    }
    @include point-lg {
      order: 1;
    }
  }
  &__item {
    display: flex;
  }
}

.payments-logo {
  display: flex;
  order: 1;
  margin-bottom: 8px;
  @include point-md {
    margin-bottom: 0;
    grid-column-start: 1;
    grid-column-end: 3;
    justify-self: center;
  }
  @include point-lg {
    order: 2;
    grid-column-start: 2;
    grid-column-end: 3;
  }
  svg {
    fill: #fff;
    opacity: 0.7;
    &:not(:last-child) {
      margin-right: 32px;
    }
  }
}
</style>
